import { devicesAdapter, DeviceState } from "./device.entity";
import { createReducer, on, Action } from "@ngrx/store";
import { devicesActionTypes } from "./device.actions";
import { authActionTypes } from "../../../auth/store/auth.actions";

export const initialState: DeviceState = devicesAdapter.getInitialState({
    ids: [],
    total: 0,
    loaded: false,
    devices: [],
    paginationMetaData: null,
    searchString: null,
    error: null
});

export const devicesReducerObj = createReducer(
    initialState,

    on(devicesActionTypes.setDevicesAction, (state, action) => {

        if ( action.devicesResponse && action.devicesResponse.Devices !== null
            && action.devicesResponse.Devices.length > 0 ) {
            return devicesAdapter.addAll(action.devicesResponse.Devices, {
                ...state,
                devices: action.devicesResponse.Devices,
                paginationMetaData: action.devicesResponse.PaginationMetaData,
                searchString: action.searchString,
                loaded: true,
                total: action.devicesResponse.PaginationMetaData.TotalCount,
                error:null
            });
        } else {
            return devicesAdapter.removeAll(state);
        }
    }),

    on(devicesActionTypes.setDevicesActionFail, (state, action) => {
            return {
            ...state,
            error: action.error
        }
    }),

    on(devicesActionTypes.clearDeviceSearchStringAction, (state, action) => ({
        ...state,
        searchString: ''
    })),

    on(devicesActionTypes.clearDevicesAction, (state, action) => {
        return devicesAdapter.removeAll(state);
    }),

    on(authActionTypes.LogOut, (state, action) => {
        return devicesAdapter.removeAll({
            ...state,
            loaded: false,
            total: 0,
        });
    }),
);

export function reducer(
    state: DeviceState = initialState,
    action: Action
): DeviceState {
    return devicesReducerObj(state, action);
}

export const devicesSelectors = devicesAdapter.getSelectors();
